package nl.astraeus.wiki.oauth

actual fun generateRandom(): String = TODO("Not supported in JS")
